<template>
<ItpModal
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="WAttachmentModal"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :id="formId"
      name="attachment"
      ref="mainForm"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <ItpFormGroup
        name="file"
        :label="'File'|pgettext('Attachment')"
        labelFor="file"
        required
        v-if="!attachment"
      >
        <ItpFormFile
          :autofocus="!attachment"
          v-model="file"
          name="file"
          required
          :placeholder="'Choose a file or drop it here'|gettext"
          :drop-placeholder="'Drop file here'|gettext"
          lang="hu"
          :validation="b_7789867021953041_validation"
        >
        </ItpFormFile>
      </ItpFormGroup>
      <ItpFormGroup
        name="description"
        :label="'Description'|gettext"
      >
        <ItpFormTextarea
          name="description"
          v-model="item.description"
          :autofocus="!!attachment"
        >
        </ItpFormTextarea>
      </ItpFormGroup>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :text="'Save'|pgettext('Button')"
      :disabled="!forms.attachment || !forms.attachment.submittable"
      type="submit"
      :form="formId"
      variant="primary"
      icon="fa-save"
      :spinning="actions.save.isRunning"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|gettext"
      variant="default"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpModal>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class WAttachmentModal extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "modal",
  };

  beforeCreate() {
  }

  @Prop({
    type: Object,
  })
  attachment!: object;

  @Watch('attachment')
  onAttachment(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("attachment")
  }

  @Prop({
    type: String,
  })
  object_id!: string;

  @Watch('object_id')
  onObject_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("object_id")
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  item!: any;

  async $$load_item() {
    return this.attachment || { object_id: this.object_id, description: null }
  }

  uploadTitle!: any;
  editTitle!: any;
  file!: any;
  ux!: any;
  b_7789867021953041_validation!: any;
  dataMembers = ['formId', 'item', 'uploadTitle', 'editTitle', 'file', 'ux', 'b_7789867021953041_validation'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        formId: null,
        item: null,
        uploadTitle: this.$fn.pgettext("Attachments", "Upload file"),
        editTitle: this.$fn.pgettext("Attachments", "Edit description"),
        file: null,
        ux: null,
        b_7789867021953041_validation: ["required"
          ,
        ]
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.attachment ? this.editTitle : this.uploadTitle,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_2598_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_2598, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_closeModal_2604_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1040167445267876_closeModal_2604, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
      }
      ,
    }
  }

  async act_1040167445267876_request_2602_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_1040167445267876_request_2602, alias=save
    return {
      operation: this.attachment ? 'update_attachment' : 'create_attachment',
      data: this.attachment ? this.item : { ...this.item, file: this.file },
      contentType: this.attachment ? 'application/json' : 'multipart/form-data',
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async act_1419464017721962_closeModal_2606_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1419464017721962_closeModal_2606, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
      }
      ,
    }
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_2598: actions.CloseModalAction;
    evh_7315092382398562_close_2597: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeModal_2600: actions.CloseModalAction;
    evh_2248226175642056_close_2599: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_closeModal_2604: actions.CloseModalAction;
    evh_1040167445267876_success_2603: actions.EventHandlerImpl;
    act_1040167445267876_request_2602: actions.RequestAction;
    evh_1040167445267876_submit_2601: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_1419464017721962_closeModal_2606: actions.CloseModalAction;
    evh_1419464017721962_clickPreventStop_2605: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_2598 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_2598_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_2597 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_2598,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_2597],
      }
    );
    const act_2248226175642056_closeModal_2600 = new actions.CloseModalAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_2599 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeModal_2600,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_2599],
      }
    );
    const act_1040167445267876_closeModal_2604 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1040167445267876_closeModal_2604_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_2603 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeModal_2604,
        event: "success",
        displayName: "closeModal",
      }
    );
    const act_1040167445267876_request_2602 = new actions.RequestAction(
      {
        actionArgs: this.act_1040167445267876_request_2602_getActionArgs,
        displayName: "save",
        events: [evh_1040167445267876_success_2603],
      }
    );
    const evh_1040167445267876_submit_2601 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_request_2602,
        event: "submit",
        displayName: "save",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_2601],
      }
    );
    const act_1419464017721962_closeModal_2606 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1419464017721962_closeModal_2606_getActionArgs,
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_2605 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeModal_2606,
        event: "click.prevent.stop",
        displayName: "closeModal",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_2605],
      }
    );
    return {
      act_7315092382398562_closeModal_2598,
      evh_7315092382398562_close_2597,
      evh_7315092382398562_close,
      act_2248226175642056_closeModal_2600,
      evh_2248226175642056_close_2599,
      evh_2248226175642056_close,
      act_1040167445267876_closeModal_2604,
      evh_1040167445267876_success_2603,
      act_1040167445267876_request_2602,
      evh_1040167445267876_submit_2601,
      evh_1040167445267876_submit,
      act_1419464017721962_closeModal_2606,
      evh_1419464017721962_clickPreventStop_2605,
      evh_1419464017721962_clickPreventStop,
      save: act_1040167445267876_request_2602,
    }
  }
}

Vue.component("WAttachmentModal", WAttachmentModal);

</script>